import ThemeTableEdit from './container';

export default ThemeTableEdit;



// WEBPACK FOOTER //
// ./src/routes/ThemeTableEdit/index.js